import React from 'react';

import CKEditor from 'ckeditor4-react';
import { ValidatorComponent } from 'react-form-validator-core';

class CkEditorValidator extends ValidatorComponent {

    render() {
        const { errorMessages, validators, requiredError, validatorListener, ...rest } = this.props;

        return (
            <>
                <CKEditor className="form-control" rows="3"
                          {...rest}
                          ref={(r) => { this.input = r; }}
                />
                {this.errorText()}
            </>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <p style={{ color: 'red' }}>
                {this.getErrorMessage()}
            </p>
        );
    }
}

export default CkEditorValidator;
